import { getBaseUrl } from './ServiceUtils';
import appRequest from './appRequest';

const DASHBOARD_URL = getBaseUrl('/dashboard/');

export async function getDashboardSummary(market) {
    const qs = market ? `?market=${market}` : '';
    return await appRequest.doGetRequest(`${DASHBOARD_URL}summary${qs}`);
}
